import { useMemo, useState } from "react";
import { Container } from "../../shared/Components/Container/Container";
import { ElementBreadCrumb } from "../../shared/Components/ElementBreadCrumb";
import { ElementItemCardGenerico } from "../../shared/Components/Programados/ElementItemCardGenerico";
import { InputSearch } from "../../shared/Components/ReactBootstrap/InputSearch/InputSearch";
import { LanguageTranslate } from "../../shared/Infraestructure/LanguageTranslate";
import { useSelector } from "react-redux";
import { RootState } from "../../shared/Infraestructure/AdapterStore";
import { ViewError } from "../../shared/Components/ViewError";
import { BantelENTITY } from "sigo-entities";
import ButtonFloating from "../../shared/Components/ButtonFloating/ButtonFloating";
import { ViewLoading } from "../../shared/Components/ViewLoading";
import { OffCanvasBottom } from "../../shared/Components/ReactBootstrap/OffCanvasBottom/OffCanvasBottom";
import { AddInventory } from "./AddInventory";
import { AdapterGenerico } from "../../shared/Infraestructure/AdapterGenerico";
import {
    useGetByIdBantelOrdersQuery,
    useLazyGetByIdBantelOrdersQuery,
    useFinalizeBantelOrdersMutation
} from "../../shared/Infraestructure/slice";
import { Adjuntos } from "./Adjuntos";

export function ViewOrdenesBantel() {
    const languageTranslate = LanguageTranslate()
    const [searchTerm, setSearchTerm] = useState<string>('')
    const [show, setShow] = useState<boolean>(false)
    const [showAdjuntos, setShowAdjuntos] = useState<boolean>(false)
    const [selectedId, setSelectedId] = useState<string | null>(null)
    const { user } = useSelector((state: RootState) => state.auth)
    const { data, isLoading, isError, error } = useGetByIdBantelOrdersQuery(user.Identificacion)
    const [getByIdBantelOrders, { data: newData, isFetching, isError: isErrorLazy, error: errorLazy }] = useLazyGetByIdBantelOrdersQuery()
    const [finalizeBantelOrders, { isLoading: isLoadingFinalizeBantelOrders }] = useFinalizeBantelOrdersMutation()
    const rutaOperaciones = '/main/operaciones'

    const currentData = newData ?? data ?? []

    const filteredData = currentData.filter((e) => {
        const term = searchTerm.trim().toUpperCase()
        if (!term) return true
        return (
            e.numero_de_peticion?.toUpperCase().includes(term) ||
            e.subtipo_de_actividad?.toUpperCase().includes(term)
        )
    })

    const selectedOrder = useMemo(
        () => data?.find((item) => item._id === selectedId),
        [data, selectedId]
    )

    const onAddInventoryClick = (e: BantelENTITY) => {
        try {
            setSelectedId(e._id)
            setShow(true)
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        }
    }

    const onAdjuntosClick = (e: BantelENTITY) => {
        try {
            setSelectedId(e._id)
            setShowAdjuntos(true)
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        }
    }

    const onFinalizeClick = async (e: BantelENTITY) => {
        try {
            const confirmacion = await AdapterGenerico.createMessage('Confirmar', `¿Estás seguro de finalizar la orden?`, 'question', true)
            if (!confirmacion) return
            await finalizeBantelOrders({ id: e._id }).unwrap()
            AdapterGenerico.createMessage('¡Éxito!', '¡Se finalizó!', 'success')
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        }
    }

    if (isLoading || isFetching) return <ViewLoading />

    return (
        <Container>
            <ElementBreadCrumb list={[
                { text: languageTranslate.menu['070'].titulo, navigate: true, path: rutaOperaciones },
                { text: languageTranslate.menu['078'].titulo, navigate: false, path: '' }]}
            />
            <InputSearch
                handleChange={(text) => setSearchTerm(text.toUpperCase())}
            />
            {
                (isError || isErrorLazy)
                    ? <ViewError error={error || errorLazy} />
                    : isLoadingFinalizeBantelOrders
                        ? <ViewLoading />
                        : <>
                            {
                                filteredData.map((e, i) => (
                                    <ElementItemCardGenerico
                                        key={i}
                                        icono
                                        onClick={() => onAddInventoryClick(e)}
                                        icono1='fa-solid fa-box-archive'
                                        icono2='fa-solid fa-check-to-slot'
                                        icono3='fa-solid fa-file-pdf'
                                        colorIcono1={e.inventory.length ? 'success' : 'warning'}
                                        colorIcono2='info'
                                        colorIcono3={e.boletin.Posicion === '' ? 'danger' : 'success'}
                                        onClick2={onFinalizeClick}
                                        onClick3={() => onAdjuntosClick(e)}
                                        text1={<span style={{ fontSize: 14 }}>Nº Petición</span>}
                                        data1={<span style={{ color: '#e0e0e0' }}>{e.numero_de_peticion}</span>}
                                        text2={<span style={{ fontSize: 14 }}>Actividad</span>}
                                        data2={<span style={{ color: '#e0e0e0' }}>{e.subtipo_de_actividad}</span>}
                                        text3={<span style={{ fontSize: 14 }}>Tipo</span>}
                                        data3={<span style={{ color: '#e0e0e0' }}>{e.tipo_orden}</span>}
                                        text4={<span style={{ fontSize: 14, color: 'white' }}>Estado</span>}
                                        data4={<span style={{ color: 'yellow' }}>{e.estado}</span>}
                                        item={e}
                                    />
                                ))
                            }
                        </>
            }
            <ButtonFloating
                onClick={async () => await getByIdBantelOrders(user.Identificacion).unwrap()}
                icono='fa-solid fa-arrows-rotate'
                colorIcono='#2C3E50'
            />
            <OffCanvasBottom
                height={100}
                show={show}
                setShow={setShow}
                children={
                    selectedOrder
                        ? <AddInventory
                            row={selectedOrder}
                        />
                        : null
                }
            />
            <OffCanvasBottom
                height={100}
                show={showAdjuntos}
                setShow={setShowAdjuntos}
                children={
                    selectedOrder
                        ? <Adjuntos
                            row={selectedOrder}
                        />
                        : null
                }
            />
        </Container>
    )
}